import gsap from 'gsap';

export const PXTabs = (function () {
	'use strict';

	function init() {
		const blocks = document.querySelectorAll('.pxblock--tabs');
		const accordionItems = document.querySelectorAll('.pxblock--tabs__accordion li');

		if (blocks.length === 0) return;

		blocks.forEach((bl) => {
			const navItems = bl.querySelectorAll('.nav-item');
			const tabs = bl.querySelectorAll('.pxblock--tabs__tab-content');

			navItems.forEach((navItem) => {
				navItem.addEventListener('click', (ev) => {
					const targetTab = Array.from(tabs).find((t) => t.id === navItem.dataset.contentId);

					navItems.forEach((n) => n.classList.remove('active'));
					tabs.forEach((n) => n.classList.remove('active'));
					navItem.classList.add('active');
					targetTab.classList.add('active');
				});
			});
		});

		accordionItems.forEach((accordionItem) => {
			accordionItem.querySelector('.trigger').addEventListener('touchstart', (ev) => {
				Array.from(accordionItems)
					.filter((el) => el !== accordionItem && el.classList.contains('open'))
					.forEach((n) => n.classList.remove('open'));

				accordionItem.classList.toggle('open');
			});
		});
	}

	return {
		init: init,
	};
})();
